import type { World } from './world.js';
import type { EventQueue } from './events.js';
import type { Player } from './entities.js';
import type { Prng } from '../prng.js';
import { emitExplosionBurst } from './effects.js';

const RESPAWN_DELAY_MS = 1000;
const INVULN_MS = 1500;

/**
 * Apply player damage. Called by collision system.
 */
export function onPlayerHit(
  world: World,
  player: Player,
  events: EventQueue,
  rng: Prng
): void {
  if (player.invulnMs > 0 || player.respawnMs > 0 || !player.alive) return;

  // Shield absorbs one hit.
  if (player.shieldHp > 0) {
    player.shieldHp -= 1;
    player.invulnMs = Math.max(player.invulnMs, 600);
    world.shake = Math.max(world.shake, 6);
    events.push({ type: 'hit', pos: { x: player.pos.x, y: player.pos.y }, team: 'player', heavy: false });
    return;
  }

  player.hp -= 1;
  if (player.hp > 0) return;

  // Died.
  events.push({ type: 'playerDeath', pos: { x: player.pos.x, y: player.pos.y } });
  emitExplosionBurst(world, { x: player.pos.x, y: player.pos.y }, rng, 24);
  world.shake = Math.max(world.shake, 12);
  world.hitStopMs = Math.max(world.hitStopMs, 80);

  player.lives -= 1;
  if (player.lives <= 0) {
    player.alive = false;
    world.phase = 'gameover';
    events.push({ type: 'gameover' });
    return;
  }

  // Queue respawn.
  player.respawnMs = RESPAWN_DELAY_MS;
  player.hp = 1;
  player.invulnMs = INVULN_MS;
  player.pos.x = world.worldWidth * 0.5;
  player.pos.y = world.worldHeight - 100;
  player.vel.x = 0;
  player.vel.y = 0;
}

/**
 * Periodic tick: nothing extra — movement system already decays invuln/respawn timers.
 */
export function updateLives(_world: World, _dtMs: number): void {
  // no-op placeholder so the system order in engine.tick can call this slot
}
